module.exports = __webpack_public_path__ + "img/chat.335db255.svg";